/**
 * Finds the topmost floating dock window under the cursor, skipping the dragged window.
 * Pure geometry (bounding rect + z-index) — independent of pointer-events / mouse events on the target.
 * @param {number} x
 * @param {number} y
 * @param {string} draggedId
 * @param {string[]} panelIds - mounted dockable windows (JxDockEngine)
 * @returns {string|null} host window id
 */
export function findDockHost(x, y, draggedId, panelIds) {
    const hits = panelIds
        .filter((id) => id !== draggedId)
        .map(toHostRect)
        .filter((h) => h && containsPoint(h.rect, x, y));

    if (hits.length === 0) return null;

    hits.sort((a, b) => b.zIndex - a.zIndex);
    return hits[0].id;
}

// Floating dock window root = element with id === windowId and data-dock-host === windowId
const toHostRect = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    if (el.dataset?.dockHost !== id) return null;
    return { id, rect: el.getBoundingClientRect(), zIndex: Number(getComputedStyle(el).zIndex) || 0 };
};

const containsPoint = (r, x, y) => x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
